// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_jl-0";
export var optionCard = "_jl-1";